/* unplugin-vue-components disabled */import script from "./mg-divider.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-divider.vue?vue&type=script&setup=true&lang=js"

import "./mg-divider.vue?vue&type=style&index=0&id=66821c61&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66821c61"]])

export default __exports__